import { useLocale } from 'containers/App/LocaleContext';
import { useMemo } from 'react';
import type { AppTranslations } from 'translations/translations';
import type { WebHookType } from '../WebHooksState';

export type TypeTranslator = (type: WebHookType) => string;

const makeGetTypeTranslation =
  (msg: AppTranslations) => (type: WebHookType) => {
    switch (type) {
      case 'snapshot':
        return msg.settings.webHooks.types.snapshot;
      case 'intent-verification':
        return msg.settings.webHooks.types['intent-verification'];
      default:
        return type;
    }
  };

export const useTypeTranslator = (): TypeTranslator => {
  const msg = useLocale();

  return useMemo(() => makeGetTypeTranslation(msg), [msg]);
};
